import React, { useState } from "react";
import "./SectionsTable.css";
import PropTypes from "prop-types";
import PlayLessonIcon from "@mui/icons-material/PlayLesson";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import axios from "axios";
import BASE_URL from "../../../config/api";
import { useParams } from "react-router";
import { AppContext } from "../../../context/AppContext";
import { useContext } from "react";

const SectionRow = ({
  section,
  onExpand,
  lessons,
  openSection,
  setOpenSection,
}) => {
  const isSectionOpen = openSection === section._id;
  const navigate = useNavigate();

  const handleExpandClick = () => {
    if (onExpand) {
      onExpand(section._id);
    }

    if (isSectionOpen) {
      setOpenSection(null);
    } else {
      setOpenSection(section._id);
    }
  };
  const { id } = useParams();
  const navigateToLesson = (lessonId) => {
    navigate(`/course/${id}/section/${section._id}/lesson/${lessonId}`);
  };
  return (
    <React.Fragment>
      <TableRow>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={handleExpandClick}
          >
            {isSectionOpen ? (
              <KeyboardArrowUpIcon />
            ) : (
              <KeyboardArrowDownIcon />
            )}
          </IconButton>
        </TableCell>
        <TableCell
          sx={{ fontWeight: "600", color: "#6D7791", fontSize: "16px" }}
        >
          {section.title}
        </TableCell>
      </TableRow>
      {isSectionOpen &&
        (lessons && lessons.length > 0 ? (
          lessons.map((lesson) => (
            <TableRow
              key={lesson._id}
              className="play-lesson-link"
              onClick={() => navigateToLesson(lesson._id)}
            >
              <TableCell style={{ color: "#223979" }}>
                <PlayLessonIcon fontSize="medium" />
              </TableCell>
              <TableCell className="lesson-title">{lesson.title}</TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={3}>
              No lessons available for this section
            </TableCell>
          </TableRow>
        ))}
    </React.Fragment>
  );
};

SectionRow.propTypes = {
  section: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  onExpand: PropTypes.func,
  lessons: PropTypes.array.isRequired,
  openSection: PropTypes.string,
  setOpenSection: PropTypes.func,
};

const SectionsTable = ({ sections }) => {
  const { id } = useParams();
  const [lessons, setLessons] = useState([]);
  const [openSection, setOpenSection] = useState(null);
  const { token } = useContext(AppContext);

  const fetchLessons = async (sectionId) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/courses/${id}/sections/${sectionId}/lessons`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLessons(response.data);
    } catch (err) {
      // console.log(err.data);
    }
  };

  return (
    <TableContainer sx={{ maxWidth: "600px" }} component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead sx={{ width: "100%", background: "#0e1937" }}>
          <TableRow>
            <TableCell />
            <TableCell
              sx={{
                color: "#ffffff",
                fontWeight: "700",
                fontSize: "1.2rem",
              }}
            >
              Chapters of the course
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sections.map((section) => (
            <SectionRow
              key={section._id}
              section={section}
              onExpand={fetchLessons}
              lessons={lessons}
              openSection={openSection}
              setOpenSection={setOpenSection}
              courseId={id}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

SectionsTable.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default SectionsTable;
